<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import {
  isEnabled,
  payloadOf,
  rgiLabel,
  textOf,
} from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const items = computed(() => {
  const payload = payloadOf(props.event);
  const registry = payload.registro || payload;
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');

  return [
    {
      label: t('POST_SALE.STATUS_DETAILS.REGISTRATION_BY_COMPANY'),
      value: isEnabled(registry.check_registro)
        ? t('POST_SALE.STATUS_DETAILS.YES')
        : t('POST_SALE.STATUS_DETAILS.NO'),
    },
    {
      label: t('POST_SALE.STATUS_DETAILS.RGI_TYPE'),
      value: rgiLabel(registry.tipo_rgi || registry.tipo_rgi_id, empty, t),
    },
    {
      label: t('POST_SALE.STATUS_DETAILS.RGI_PROTOCOL'),
      value: textOf(registry.protocolo_rgi, empty, t),
    },
  ];
});
</script>

<template>
  <PostSaleStatusDetailSection
    :title="t('POST_SALE.STATUS_DETAILS.TRACKING')"
    :items="items"
  />
</template>
